module.exports = __webpack_public_path__ + "img/telemedecine2.cb804cd2.png";